import { Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { Circle } from "akar-icons";
import React from "react";

import { useMobileQuery } from "@customer-app/account/views/OperationAquarius/utils";

import { StyledStack } from "../../../constants";
import { IModalSelectionButtons } from "../../types";
import { CircleCheck } from "../CircleCheck";

export const ModalSelectionButton = ({
  onClick,
  type,
  activeSelection,
  Icon,
  subtitle,
  title,
}: IModalSelectionButtons) => {
  const isActive = activeSelection === type;
  const isMobile = useMobileQuery();
  return (
    <StyledStack
      active={isActive}
      isMobile={isMobile}
      onClick={() => onClick(type)}
      className={prefixClassName("modal-selection-button", `${isActive ? "active" : "inactive"}`)}
    >
      <div className="inner">
        <Icon />
        <Typography variant="h4" margin="0">
          {title}
        </Typography>
        <Typography variant="body1" margin="0">
          {subtitle}
        </Typography>
      </div>
      <div className="selection-icon"> {isActive ? <CircleCheck /> : <Circle />}</div>
    </StyledStack>
  );
};
